import "./Header.scss"
const Header = () => (
  <div className="header">
      <h2>Realtime Chat App</h2>
  </div>
);

export default Header;